import React from "react";
import { Confirmation } from "../../../secondary";
import warning from "../../../../static/images/icon-check-danger.png";
import constants from "../../../../constants/constants.json";
import { Button } from "../../../primary";
import style from "./assessmentNotes.module.scss";
import { useLoading } from "../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../constants/loadingKeys";
import { Spinner } from "../../../secondary/Loader/Spinner";

const NotesDeleteConfirmationModal = ({ setDeleteModal, handleDelete }) => {
  const deleteAssessmentNoteLoading = useLoading(LOADING_KEYS.DELETE_ASSESSMENT_NOTE);
  return (
    <Confirmation onClose={() => setDeleteModal(false)} title={" "}>
      <div className="text-center pr-5 pl-5">
        <div>
          {deleteAssessmentNoteLoading ? <Spinner className="p-0" /> : (
            <img src={warning} alt="warnning-icon" />
          )}
        </div>
        <div className="pb-3">{constants.deleteConfirmation}</div>
        <div className="mb-2">
          <Button value="Yes" classes={{ className: `btn mr-2 pb-2 pt-2 mr-3 ${style.btn_primary}` }} onClick={handleDelete} />
          <Button value="No" classes={{ className: `btn ml-2 pb-2 pt-2 ${style.btn_scondary}` }} onClick={() => setDeleteModal(false)} />
        </div>
      </div>
    </Confirmation>
  );
};

export default NotesDeleteConfirmationModal;
